module.exports = __webpack_public_path__ + "static/media/test5.a42b11ab.jpg";